var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{on:{"input":function($event){return _vm.$emit('input', _vm.content)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }